import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import authService from "@/services/auth";
import {AxiosPlugin} from "@/plugins/axios";
import VueExcelEditor from 'vue-excel-editor'
Vue.use(VueExcelEditor)


Vue.config.productionTip = false
Vue.use(AxiosPlugin);


let app: unknown = null;
authService.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }
});
